import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import {
  ChartTimeZone,
  DEFAULT_CHART_TIME_ZONE,
  isChartTimeZone,
} from '@/shared/utils/date';

type ChartTimeZoneState = {
  timeZone: ChartTimeZone;
  setTimeZone: (timeZone: ChartTimeZone) => void;
};

// Persisted per browser so the serverless charts keep the chosen time zone
// across reloads and between the tier pages.
export const useChartTimeZoneStore = create<ChartTimeZoneState>()(
  persist(
    (set) => ({
      timeZone: DEFAULT_CHART_TIME_ZONE,
      setTimeZone: (timeZone) => set({ timeZone }),
    }),
    {
      name: 'autoops.chartTimeZone',
      partialize: (state) => ({ timeZone: state.timeZone }),
      merge: (persisted, current) => {
        const stored = (persisted as Partial<ChartTimeZoneState> | undefined)
          ?.timeZone;

        return {
          ...current,
          timeZone: isChartTimeZone(stored) ? stored : DEFAULT_CHART_TIME_ZONE,
        };
      },
    }
  )
);
